export { TrackingProvider } from './TrackingProvider';
export { SensitiveContentComponent } from './SensitiveContentComponent';
export type { SensitiveContentComponentProps } from './SensitiveContentComponent';
export { TrackViewComponent } from './TrackViewComponent';
export type { ViewComponentProps } from './TrackViewComponent';
export {
  pushToDataLayer,
  getDataLayerEnvironment,
  keepFromTracking,
  getIsClientIdEvent,
  getIsGtmStartEvent,
  setupDataLayer,
} from './dataLayerActions';
export { useTracking } from './hooks/useTracking';
export { PageViewTracker } from './pageView/PageViewTracker';
export { PageViewContext, usePageView } from './pageView/PageViewContext';
export type {
  PageViewContextType,
  VirtualPageViewOptions,
  NavigationPageViewOptions,
} from './pageView/PageViewContext';
export { usePageViewTracking } from './pageView/usePageViewTracking';
export type { UsePageViewTrackingProps } from './pageView/usePageViewTracking';
export { buildPageViewEvent } from './pageView/buildPageViewEvent';
export type { PageViewInput, PageViewProfile } from './pageView/buildPageViewEvent';
export { getViewportType } from './pageView/getViewportType';
export { buildPageLocation, normalizePagePath, normalizeReferrer } from './pageView/normalizePath';
export { useGTM, GTMProvider, GTMContext, GTM, GTMTestProvider } from './gtm';
export * from './types';
